// FillInBlank.js
import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

// Define some basic styles
const styles = StyleSheet.create({
  container: {
    marginBottom: 12,
  },
  sentence: {
    marginBottom: 6,
    fontSize: 12,
    lineHeight: 1.4,
  },
  correctAnswer: {
    marginBottom: 6,
    fontSize: 24,
    lineHeight: 1.4,
    fontWeight: 600
  },
  wordBankContainer: {
    border: 1,
    borderColor: 'black',
    borderRadius: '12px',
    padding: '12px',
  },
  wordBankTitle: {
    fontSize: 12,
    fontWeight: "bold",
    // marginTop: 10,
    marginBottom: 4,
    textDecoration: "underline",
  },
  wordBank: {
    fontSize: 12,
    fontStyle: "italic",
  },
});

// Simple shuffle function using Fisher-Yates algorithm
function derangedShuffle(array) {
  // For arrays with 0 or 1 element, there is no alternative permutation.
  if (array.length <= 1) return array;

  const newArr = array.slice();
  // Sattolo’s algorithm: i from n-1 downto 1, with j uniformly chosen from 0 to i-1.
  for (let i = newArr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * i); // note: random integer in [0, i)
    [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
  }
  return newArr;
}

export default function FillInBlank({ data, typeOfContent }) {
  return (
    <View style={styles.container}>
      {/* Render each sentence */}
      {data.map((item, index) => (
        <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          {/* <Text key={index} style={styles.sentence}>
            {index + 1}. {item.sentence}
          </Text> */}

          {typeOfContent === "homework_marksheet" ? (
            <Text key={index} style={styles.sentence}>
              {index + 1}. {item.answer}
            </Text>
          ) : (
            <Text key={index} style={styles.sentence}>
              {index + 1}. {item.sentence}
            </Text>
          )}

        </View>
      ))}
    </View>
  );
}
